import type { FC } from 'react';
import { Box, Grid, ErrorBoundary } from '@packages/shared';
import type { CmsData } from '@packages/cms-components/interfaces';
import { ContentExternal } from '@packages/cms-components';
import type { SearchSeoApiResponse, Brand, BrandHeadline } from '../../api/rest/types';
import { BrandList } from '../BrandList';
import { ProductListSeo } from '../ProductListSeo';

export type CategoryPageBrandOverviewProps = {
  cmsContent?: CmsData | null;
  seoResponse?: SearchSeoApiResponse | null;
  brands: Brand[];
  brandHeadlines: BrandHeadline[];
};

/**
 * Page content for Brands page
 * */
export const CategoryPageBrandOverview: FC<CategoryPageBrandOverviewProps> = ({
  cmsContent,
  seoResponse,
  brands,
  brandHeadlines,
}) => (
  <Grid container spacing={0.5}>
    <Grid item>
      {cmsContent && (
        <ErrorBoundary>
          <ContentExternal data={cmsContent} />
        </ErrorBoundary>
      )}
      <Box
        sx={{
          padding: (theme) => theme.spacing(1),
        }}
      >
        <BrandList brands={brands} brandHeadlines={brandHeadlines} />
      </Box>

      {seoResponse && <ProductListSeo data={seoResponse} />}
    </Grid>
  </Grid>
);
